// extracted by mini-css-extract-plugin
export default {"share-links":"ShareLinks_share-links__dQERa"};